import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Cards = ({ favorite }) => {
  return (
    <>
      <Card
        style={{ width: "18rem", border: "0", marginBottom: "50px" }}
        className="col-sm-3"
      >
        <Card.Img
          style={{ height: "250px", borderRadius: "10px 10px 0 0" }}
          variant="top"
          src={favorite.Poster}
        />
        <Card.Body className="border shadow">
          <Card.Title>{favorite.Title}</Card.Title>
          <Link
            to={{ pathname: `/detailMovie/${favorite.Title}`, state: favorite }}
          >
            <Button variant="info">See Details</Button>
          </Link>
        </Card.Body>
      </Card>
    </>
  );
};

export default Cards;
